export const isFileAPISupported = typeof File !== "undefined";
